import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Login from "./Login";
import Dashboard from "./Dashboard";
import Navbar from "./Navbar";
import PurchaserReport from "./PurchaserReport";
import StockForm from "./StockForm";
import Register from "./Register";
import UserAccessControl from "./UserAccessControl";
import SalesByItems from './salesbyitems';
import SalesItems1 from './SalesItems1';
import PurchaseItems from './PurchaseItems';
import SummaryForm from "./SummaryForm";
import PurchaseByCustomer from "./purchasebycustomer";
import AttendanceReport from "./AttendanceReport";
import MonthlyBudget1 from "./MonthlyBudget1";
import ItemTable from "./ItemTable";
import ItemTableViewer from "./ItemTableViewer";
import EmpGapForm from "./EmpGapForm";
import LogoutIcon from "@mui/icons-material/Logout";

import "bootstrap/dist/css/bootstrap.min.css";
import "./PortalTheme.css";
function App() {
  const location = useLocation();
  const isSalesByItemsRoute = location.pathname.toLowerCase() === "/salesbyitems";
  // -------------------- Auth State --------------------
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [currentUser, setCurrentUser] = useState(() => {
    const saved = localStorage.getItem("currentUser");
    try {
      return saved ? JSON.parse(saved) : null;
    } catch {
      localStorage.removeItem("currentUser");
      return null;
    }
  });

  const [collapsed, setCollapsed] = useState(true);
  const clearSession = () => {
    // End the account-scoped preference session while preserving the saved view.
    fetch("/api/report-preferences/session", {
      method: "DELETE", credentials: "same-origin", keepalive: true,
      headers: { "X-Report-Preferences": "1" },
    }).catch(() => {});
    [
      "currentUser",
      "token",
      "username",
      "userRole",
      "permissions",
      "access",
      "loggedUser",
      "isAuthenticated",
    ].forEach((key) => localStorage.removeItem(key));
  };

  const logout = () => {
    clearSession();
    setCurrentUser(null);
    setToken(null);
    window.location.reload();
  };

  const handleLogin = (newToken) => {
    localStorage.setItem("token", newToken);
    setToken(newToken);
  };

  const handleLogout = () => {
    clearSession();
    setCurrentUser(null);
    setToken(null);
  };

  // -------------------- Sidebar & other states --------------------
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => localStorage.getItem("sidebar-collapsed") === "true");

  const standaloneLogoutButton = {
    display: "inline-flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px 16px",
    borderRadius: "14px",
    border: "1px solid #bbf7d0",
    background: "linear-gradient(135deg, #f0fdf4, #dcfce7)",
    color: "#166534",
    fontWeight: 700,
    boxShadow: "0 10px 25px rgba(22, 101, 52, 0.10)",
    cursor: "pointer",
  };

  const renderTopLogout = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: "16px",
      }}
    >
      <button onClick={logout} style={standaloneLogoutButton}>
        <LogoutIcon fontSize="small" />
        Logout
      </button>
    </div>
  );

  // -------------------- Render --------------------
  if (!currentUser) {
    return (
      <Routes>
        <Route
          path="/"
          element={
            <Login
              onLogin={(user) => {
                localStorage.setItem("currentUser", JSON.stringify(user));
                setCurrentUser(user);
              }}
            />
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    );
  }

  const role = String(currentUser.role || "").toLowerCase();
// =======================================
// PDF VIEWER (NO NAVBAR, NO SIDEBAR)
// =======================================
if (role === "pdfviewer") {
  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "40px",
        background: "#f4f6f9",
      }}
    >
      {renderTopLogout()}
      <Routes>
        <Route path="/dashboard" element={<Dashboard logout={logout} />} />
        <Route path="/ItemTableViewer" element={<ItemTableViewer />} />
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    </div>
  );
}

 // 2. ITEM ADMIN (FULL ITEM PRICING ACCESS)
  // =====================================================
  if (role === "itemadmin") {
  return (
    <div className="app-layout">
      <main
        style={{
          marginLeft: "0px",
          padding: "20px",
        }}
      >
          {renderTopLogout()}
          <Routes>
            <Route path="/dashboard" element={<Dashboard logout={logout} />} />
            <Route path="/ItemTable" element={<ItemTable currentUser={currentUser} />} />
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </Routes>
        </main>
      </div>
    );
  }


// =====================================================
 


if (role === "limited" || role === "purchaser") {
  let accessList = [];

  try {
    accessList = Array.isArray(currentUser.access)
      ? currentUser.access
      : JSON.parse(currentUser.access || "[]");
  } catch {
    accessList =
      typeof currentUser.access === "string"
        ? currentUser.access.split(",").map((x) => x.trim())
        : [];
  }

  accessList = accessList.map(a => a.toLowerCase().replace(/\s+/g,''));

  return (
    <div className="app-layout portal-shell" data-sidebar={isSidebarCollapsed ? "compact" : "expanded"}>
      <Navbar onLogout={logout} onToggle={setIsSidebarCollapsed} />

      <main
        className="main-content"
        style={{
          marginLeft: isSidebarCollapsed ? "70px" : "260px",
          padding: isSalesByItemsRoute ? "20px 20px 20px 12px" : "20px",
        }}
      >
        <Routes>
          <Route path="/dashboard" element={<Dashboard logout={logout} />} />

          {accessList.includes("salesbyitems") && <Route path="/salesbyitems" element={<SalesByItems />} />}
          {accessList.includes("salesitems1") && <Route path="/SalesItems1" element={<SalesItems1 />} />}
          {accessList.includes("purchaseitems") && <Route path="/PurchaseItems" element={<PurchaseItems />} />}
          {accessList.includes("purchasebycustomer") && <Route path="/purchasebycustomer" element={<PurchaseByCustomer />} />}
          {accessList.includes("purchaserreport") && <Route path="/PurchaserReport" element={<PurchaserReport user={currentUser} onLogout={logout} />} />
}

          {accessList.includes("monthlybudget1") && <Route path="/MonthlyBudget1" element={<MonthlyBudget1 />} />}
          {accessList.includes("stockentry") && <Route path="/StockForm" element={<StockForm />} />}
         {accessList.includes("useraccesscontrol") && 
  <Route path="/useraccesscontrol" element={<UserAccessControl currentUser={currentUser} />} />
}
{accessList.includes("itemtableviewer") && (
  <Route path="/ItemTableViewer" element={<ItemTableViewer />} />
)}
          {accessList.includes("employeereport") && <Route path="/EmpGapForm" element={<EmpGapForm currentUser={currentUser} logout={logout} />} />}
          
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </main>
    </div>
  );
}


  if (role === "transfer") {
    return (
      <div
        style={{
          padding: "20px",
          backgroundColor: "#f9fafb",
          minHeight: "100vh",
        }}
      >
        {renderTopLogout()}
        <Routes>
          <Route path="/dashboard" element={<Dashboard logout={logout} />} />
          <Route path="/StockForm" element={<StockForm user={currentUser} onLogout={logout} />} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </div>
    );
  }
let accessList = [];

try {
  accessList = Array.isArray(currentUser.access)
    ? currentUser.access
    : JSON.parse(currentUser.access || "[]");
} catch {
  accessList = typeof currentUser.access === "string"
    ? currentUser.access.split(",").map((x) => x.trim())
    : [];
}


  if (role === "employeeform") {
    return (
      <div
        style={{
          padding: "20px",
          backgroundColor: "#f9fafb",
          minHeight: "100vh",
        }}
      >
        <Routes>
          <Route path="/dashboard" element={<Dashboard logout={logout} />} />
          <Route path="/EmpGapForm" element={<EmpGapForm user={currentUser} onLogout={logout} />} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </div>
    );
  }

  // Other Roles -> Full Access WITH SIDEBAR + NAVBAR
  return (
    <div className="app-layout portal-shell" data-sidebar={isSidebarCollapsed ? "compact" : "expanded"}>
      <Navbar onLogout={logout} onToggle={setIsSidebarCollapsed} />
      <main
        className="main-content"
        style={{
          marginLeft: isSidebarCollapsed ? "70px" : "260px",
          paddingLeft: isSalesByItemsRoute ? "12px" : "20px",
          paddingTop: "20px",
          paddingRight: "20px",
          paddingBottom: "20px",
          transition: "margin-left 0.3s ease",
        }}
      >
        <Routes>
          <Route path="/dashboard" element={<Dashboard logout={logout} />} />
          <Route path="/SalesItems1" element={<SalesItems1 />} />
          <Route path="/salesbyitems" element={<SalesByItems />} />
          <Route path="/SummaryForm" element={<SummaryForm />} />
          <Route path="/PurchaseItems" element={<PurchaseItems />} />
          <Route path="/purchasebycustomer" element={<PurchaseByCustomer />} />
        <Route 
  path="/UserAccessControl" 
  element={<UserAccessControl currentUser={currentUser} />} 
/> 
          <Route path="/register" element={<Register />} />
          <Route path="/PurchaserReport" element={<PurchaserReport />} />
          <Route path="/AttendanceReport" element={<AttendanceReport />} />
          <Route path="/EmpGapForm" element={<EmpGapForm />} />
          <Route path="/MonthlyBudget1" element={<MonthlyBudget1 />} />
          <Route path="/StockForm" element={<StockForm onLogout={logout} />} />
          <Route path="/ItemTable" element={<ItemTable currentUser={currentUser} />} />
          <Route path="/login" element={token ? <Navigate to="/" /> : <Login onLogin={handleLogin} />}/>
          <Route path="/" element={token ? <Navigate to="/dashboard" /> : <Navigate to="/login" />}/>
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
